<!--<ng-content></ng-content>-->
<!--<ng-content select="[from-disk-tab-extra-content]"></ng-content>-->

<!--<ag-shr-image-preview-->
<!--  [src]="imagePreviewUrl"-->
<!--  [size]="size"-->
<!--  [placeholder]="placeholder"-->
<!--  (isValidChange)="handleIsFileValid($event)"-->
<!--&gt;-->
<!--  <input-->
<!--    #fileInput-->
<!--    class="upload-from-disk-tab__drop-zone-input"-->
<!--    type="file"-->
<!--    (change)="fileChangeEvent($event)"-->
<!--    [accept]="accept"-->
<!--  />-->
<!--</ag-shr-image-preview>-->


<div class="content-column">
  <ng-content></ng-content>
  <ng-content select="[from-disk-tab-extra-content]"></ng-content>
</div>

<div class="preview-column">
  <ag-shr-image-preview
    [src]="imagePreviewUrl"
    [size]="size"
    [placeholder]="''"
    (isValidChange)="handleIsFileValid($event)"
  >
    <div class="upload-from-disk-tab__drop-zone-hint" *ngIf="!imagePreviewUrl">
      {{ placeholder || 'Click or drag an image here' }}
    </div>
    <input
      #fileInput
      class="upload-from-disk-tab__drop-zone-input"
      type="file"
      (change)="fileChangeEvent($event)"
      [accept]="accept"
    />
  </ag-shr-image-preview>
  <div class="upload-from-disk-tab__quality-controls" *ngIf="isImageSelected">
    <div class="upload-from-disk-tab__quality-label">
      Quality {{ qualityPercent }}%
      <span
        class="upload-from-disk-tab__quality-status"
        [class.upload-from-disk-tab__quality-status--active]="isOptimizing"
      >
        · optimizing…
      </span>
    </div>
    <div class="upload-from-disk-tab__quality-buttons">
      <button
        type="button"
        class="upload-from-disk-tab__quality-button"
        (click)="adjustQuality(-qualityStep)"
        [disabled]="isOptimizing || qualityPercent <= minQualityPercent"
        aria-label="Decrease quality"
      >
        -
      </button>
      <button
        type="button"
        class="upload-from-disk-tab__quality-button"
        (click)="adjustQuality(qualityStep)"
        [disabled]="isOptimizing || qualityPercent >= maxQualityPercent"
        aria-label="Increase quality"
      >
        +
      </button>
    </div>
    <div class="upload-from-disk-tab__quality-meta" *ngIf="originalSizeBytes || optimizedSizeBytes">
      <span *ngIf="originalSizeBytes">Orig {{ formatBytes(originalSizeBytes) }}</span>
      <span *ngIf="optimizedSizeBytes">Now {{ formatBytes(optimizedSizeBytes) }}</span>
    </div>
  </div>
</div>
